<article class="tipsArt border-0">
  <h4 class="text-primary font-weight-bold mb-0">{{articleDetail.title}}</h4>
  <p>{{articleDetail.summary}}</p>
  <p [innerHtml]="articleDetail.answer==null ? 'NA' : articleDetail.answer | safeHTMLtags: 'html'"></p>
</article>